export enum AccApplicationDeferredStatus {
	NotDeferred = 'Not Deferred',
	Deferred = 'Deferred',
	DeferredOptedOut = 'Deferred - Opted Out'
}